<p>
  Захранването на вашата потребителска сметка (портфейл) в платформата е необходимо при наличие на
  <strong>отрицателен баланс</strong> – след начислена такса при успешно реализирана продажба. Процедурата е бърза,
  лесна и напълно сигурна.
</p>
<h6 class="mt-3">1. Къде да проверите текущия си баланс?</h6>
<p class="mb-1">
  Може да видите актуалното състояние на сметката си в следните секции от профила:
</p>
<ul>
  <li><strong>„Профил“ → „Портфейл“</strong></li>
  <li><strong>„Профил“ → „Основни данни“</strong></li>
</ul>
<h6 class="mt-3">2. Стъпки за захранване</h6>
<ol>
  <li>Навигирайте до <strong>„Профил“ → „Портфейл“</strong>.</li>
  <li>Натиснете бутона <strong>„Захранване на сметка“</strong>.</li>
  <li>Изберете предпочитан <strong>начин на плащане</strong>:
    <ul>
      <li>Плащане чрез <strong>ePay</strong>;</li>
      <li>Плащане с <strong>банкова карта</strong>.</li>
    </ul>
  </li>
  <li>Въведете сумата, с която искате да захраните акаунта си. <strong>Минималната стойност е 1.00 лв.</strong></li>
  <li>Следвайте инструкциите, за да завършите плащането през избраната платформа.</li>
</ol>
<h6 class="mt-3">3. Какво се случва след плащането?</h6>
<p>
  При успешно извършено плащане, сумата ще се отрази по баланса ви. Ще получите и потвърждение по имейл.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Захранвайте профила си навреме, особено ако имате отрицателен баланс. Това ще ви гарантира
  пълен достъп до всички функции на платформата, включително публикуване на нови обяви.
</div>
